type SentrySeverity = 'fatal' | 'error' | 'warning' | 'info' | 'debug';

let sentryModulePromise: Promise<typeof import('@sentry/react')> | null = null;

const getSentryModule = () => {
  if (!sentryModulePromise) {
    sentryModulePromise = import('@sentry/react');
  }

  return sentryModulePromise;
};

export const reportMessage = (
  message: string,
  severity: SentrySeverity = 'error'
) => {
  void getSentryModule()
    .then((sentry) => {
      sentry.captureMessage(message, severity);
    })
    .catch(() => {});
};

export const reportException = (
  error: unknown,
  context?: Record<string, unknown>
) => {
  void getSentryModule()
    .then((sentry) => {
      sentry.withScope((scope) => {
        if (context) scope.setExtras(context);
        sentry.captureException(error);
      });
    })
    .catch(() => {});
};
